import { ThemeService } from './core/services/theme.service';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from '../environments/environment';
import { FirebaseNotificationService } from './core/services/firebase-notification.service';
import { HttpService } from './core/services/general.service';
import { from, switchMap, tap } from 'rxjs';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSpinnerModule],
  standalone: true,
  templateUrl: './app.component.html',
  styles: [],
})
export class AppComponent {
  title = 'UveraDashboard';
  themeService = inject(ThemeService);
  // firebaseNotificationService = inject(FirebaseNotificationService);
  httpService = inject(HttpService);

  constructor() {
    this.themeService.initTheme();
  }

  ngOnInit() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.GOOGLE_MAPS_KEY}&loading=async&libraries=places,geocoding,marker`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    // from(this.firebaseNotificationService.requestPermission())
    //   .pipe(
    //     tap((token) => console.log('Token:', token)),
    //     switchMap((token) =>
    //       this.httpService.post('notifications/notification-preference', {
    //         fcm_token: token,
    //       })
    //     )
    //   )
    //   .subscribe((res) => console.log(res));
    // this.firebaseNotificationService.listen((m) => {
    //   console.log('Notification:', m);
    // });
  }
}
